
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";
import IrbGptSection from "@/components/sections/IrbGptSection.vue";

interface IStep2 {
  procedure: string;
  purpose: string;
  method: string;
}

export default defineComponent({
  name: "step-3",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
    IrbGptSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Purpose",
        descriptions: [
          {
            description:
              "The ''research purpose'' is the primary aim or objective of the study, specifying what the research intends to accomplish or discover.” Some Information",
          },
        ],
      },
      {
        title: "Methodology",
        descriptions: [
          {
            description:
              "This section should include a description of your research design, intervention components, theoretical framework supporting the research, variables being measured, data collection instruments, and data analysis plan.",
          },
        ],
      },
      {
        title: "Procedures",
        descriptions: [
          {
            description:
              "This section should describe the step-by-step process of how the study will be carried out including from recruitment, administering informed consent, details of data collection (who is collecting data, when, and where), and timeline and location of intervention (who is providing the intervention, frequency of intervention, when, and where).",
          },
        ],
      },
    ];
    const step2 = ref<IStep2>({
      procedure: "",
      purpose: "",
      method: "",
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      step2.value.procedure =
        data.data.procedure != null && data.data.procedure != undefined
          ? data.data.procedure
          : "";
      step2.value.method =
        data.data.method != null && data.data.method != undefined
          ? data.data.method
          : "";
      step2.value.purpose =
        data.data.purpose != null && data.data.purpose != undefined
          ? data.data.purpose
          : "";
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    return {
      step2,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
